import * as React from "react";
import { Spinner, SpinnerSize } from "office-ui-fabric-react";
/* global Spinner */

export default class Progress extends React.Component<any> {

  render() {
    return (
      <section className="ms-panel__progress ms-u-fadeIn500">
        <Spinner size={SpinnerSize.large} />
      </section>
    );
  }
}
